import Component from 'vue-class-component';
import ClientListElement from '@/components/ClientListElement/ClientListElement.vue';
import ClientListAbstract from '@/components/ClientAbstract/ClientListAbstract'

@Component({
    components: {
        ClientListElement
    }
})
export default class ClientList extends ClientListAbstract {
}